$(document).ready(function(){
    'use strict';
    const sliderYear = $('.slider-year__slider');
    const slideYear = $('.slider-year__item');
    const sliderInfo = $('.slider-info');
    const infoBlock = $('.chronicle__block');
    const infoBlockHeight = $('.chronicle__height');
    const buttonStart = $('.js-chronicle-start');
    const buttonEnd = $('.js-chronicle-end');
    let year = 1988;

    function slickCarousel() {
        const arrowNext = $('.slider-img__arrow--next');
        const arrowPrev = $('.slider-img__arrow--prev');
        const sliderImg = $('.slider-img__slider');
        const sliderImgItem = $('.slider-img__item');
        const activeNumber = $('.slider-img__active-number');
        const totalNumberSlide = $('.slider-img__total');
        const sliderCounter = $('.slider-img__counter');

        sliderImg.slick({
            infinite: true,
            arrows: true,
            nextArrow: arrowNext,
            prevArrow: arrowPrev,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

        if (sliderImgItem.length > 0) {
            sliderCounter.addClass('slider-img__counter--active');
        };

        totalNumberSlide.text(sliderImgItem.length);

        sliderImg.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            activeNumber.text(nextSlide + 1);
        });
    }

    function getChronicleInfo(year) {
        $.ajax({
            type: 'POST',
            url: `/ajax/chronicle?year=${year}`,
            dataType: "html",
            beforeSend: function () {
                infoBlock.removeClass('chronicle__block--active');
                infoBlockHeight.addClass('chronicle__height--active');
            },
            success: function (data) {
                infoBlockHeight.removeClass('chronicle__height--active');
                sliderInfo.html(data);
                infoBlock.addClass('chronicle__block--active');

                slickCarousel();
            },
            errors: function (errors) {
                console.log(errors);
            }
        });
    }

    //Настройки слайдера
    if (location.href.indexOf('chronicle') >= 0) {

        const sliderYearArrowNext = $('.slider-year__arrow--next');
        const sliderYearArrowPrev = $('.slider-year__arrow--prev');

        sliderYear.slick({
            arrows: true,
            infinite: false,
            nextArrow: sliderYearArrowNext,
            prevArrow: sliderYearArrowPrev,
            draggable: false,
            speed: 300,
            centerMode: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        // centerMode: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        getChronicleInfo(year);

        //Определение года следующего слайда
        sliderYear.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            sliderInfo.empty();
            year = slideYear[nextSlide].innerText;

            getChronicleInfo(year);
        });


        slideYear.on('click', function () {
            const slideIndex = $(this).parents('.slick-slide').attr('data-slick-index')

            sliderYear.slick('slickGoTo', slideIndex)
        })
    }

    if (location.href.indexOf('chess/') >= 0) {
        slickCarousel();
    }

    if (buttonStart) {
        buttonStart.on('click', function () {
            getChronicleInfo('1988');
            sliderYear.slick('slickGoTo', '0')
        })
    }

    if (buttonEnd) {
        buttonEnd.on('click', function () {
            const lastYear = slideYear[slideYear.length - 1].innerText;

            getChronicleInfo(lastYear);
            sliderYear.slick('slickGoTo', String(slideYear.length - 1))
        })
    }
});
